module.exports = "<navbar></navbar>\n<h1>This page is currently under devlopment</h1>\n<h1>Profle</h1>\n<div class=\"picture-container\"><img src=\"https://i.imgur.com/PsUj43r.jpg\"></div>\n\n<h3>Description</h3>\n<p>Placeholder for a short bio</p>\n\n<h3>Desired Restaurants</h3>\n<p>placeholder for restaurants this user wishes to visit</p>\n<h3>Currently Scheduled restaurant</h3>\n<p>Current reservations</p>\n<h1>Future thoughts go here the profile is not mvp</h1>"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/profile/profile.component.html
// module id = ../../../../../src/app/profile/profile.component.html
// module chunks = main